module.exports = __webpack_public_path__ + "static/media/01.ea03dbe5.jpg";